import React from "react";
import { IoEyeOffOutline, IoEyeOutline } from "react-icons/io5";
import * as Form from "@radix-ui/react-form";
import {
  FieldButtonIcon,
  FieldMessage,
  FormField,
  Input,
  InputWrapper,
} from "../Styles";

export default function PasswordInput({
  label,
  name,
  register,
  errors,
  showPassword,
  setShowPassword,
  validatePasswordMatch = null,
}) {
  return (
    <FormField name={name}>
      <Form.Label>{label}</Form.Label>
      <InputWrapper>
        <Form.Control asChild>
          <Input
            type={showPassword ? "text" : "password"}
            {...register(name, {
              required: "Password is required",
              minLength: {
                value: 8,
                message: "Password must be at least 8 characters",
              },
              pattern: {
                value:
                  // eslint-disable-next-line no-useless-escape
                  /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+{}\[\]:;<>,.?~\\-]).{8,}$/,
                message:
                  "Password must include at least one uppercase letter, one lowercase letter, one number, and one special character",
              },
              validate: (value) => {
                if (!validatePasswordMatch) return true;
                return validatePasswordMatch(value);
              },
            })}
          />
        </Form.Control>
        <FieldButtonIcon
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          aria-label={showPassword ? "Hide password" : "Show password"}
        >
          {showPassword ? (
            <IoEyeOffOutline size="16px" />
          ) : (
            <IoEyeOutline size="16px" />
          )}
        </FieldButtonIcon>
      </InputWrapper>
      {errors[name] && (
        <FieldMessage type="error">{errors[name].message}</FieldMessage>
      )}
    </FormField>
  );
}
